const makeKeyListener = (keys, listener) => {
  return (evt) => {
    const matchingKey = keys.find((it) => it === evt.key);
    if (matchingKey !== void 0) {
      listener(evt, matchingKey);
    }
  };
};

export { makeKeyListener };
//# sourceMappingURL=makeKeyListener.js.map
